module.exports = __webpack_public_path__ + "media/images/projects/9-logo-01e8ce8173ae0cd9ebd1e023508df48b.png";